import React, { Component } from 'react';
import { ThemeProvider } from '@mui/styles';
import login_navender_logo from '../images/navender_logo.png';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';
import Swal from "sweetalert2";
const apiUrl = RUN_TIME_API_ENDPOINT;

class ForgotPassword extends Component {
    state = {
        email: '',
        password: '',
        emailError: false,
        validFields: false,
        accessBlocked: false,
        unauthorized: false,
        showLoader: false,
        showMessage: false,
        resMessage: '',
        notValidUser: false,
    }

    validateFields = (email) => {
        console.log('inside validateFields');
        let validFields = false;
        let emailError = false
        const emailRegex = RegExp(
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
          );
          console.log('asaasa===>', emailRegex.test(email))
        if (!email || !emailRegex.test(email)) {
            console.log('email inside validateFields===>', email);
            validFields = false;
            emailError = true;
        } else if (email) {
            validFields = true;
            emailError = false;
        }
        // this.setState({
        //     validFields,
        //     emailError,
        //     passwordError,
        // }, () => this.state.validFields)
        return { validFields, emailError }
    }

    submit = (e) => {
        const { state } = this;
        // console.log('email inside submit=====>', state.email);
        // console.log('pwd inside submit=====>', state.password);
        console.log('inside submit===>');
        let url = "";
        e.preventDefault();
        const checkFields = this.validateFields(state.email);
        this.setState({
            ...checkFields,
            notValidUser: false,
        });
        if (checkFields.validFields) {
            this.setState({
                showLoader : true,
            })
            url = `${apiUrl}/forgot-password`;
            const options = CommonHeaderOption();
            options.method = 'POST';
            options.headers = {
                // 'authorization': tokenId,
                'Content-Type': 'application/json'
            };
            options.body = JSON.stringify({ email: this.state.email });
            return fetch(url, options)
                .then(res => {
                    console.log('res inside new login===>', res);
                    console.log('no okkay //////', this.state.unauthorized, this.state.accessBlocked);
                    if (res.status == 403) {
                        this.setState({
                            resMessage: res.message,
                            accessBlocked: true,
                            unauthorized: false,
                            showLoader: false,
                        });
                        // throw new Error(res.statusText);
                    } else if (res.status == 401) {
                        this.setState({
                            resMessage: res.message,
                            unauthorized: true,
                            accessBlocked: false,
                            showLoader: false,
                        });
                    } else if(res.status == 404 || res.status == '404') {
                        this.setState({
                            resMessage: res.message,
                            notValidUser: true,
                            unauthorized: false,
                            accessBlocked: false,
                            showLoader: false,
                        });
                    }
                    else {
                        this.setState({
                            resMessage: res.message,
                            unauthorized: false,
                            accessBlocked: false,
                            showLoader: false,
                        });
                    }
                    console.log('okkay //////', this.state.unauthorized, this.state.accessBlocked);
                    return res.json();
                })
                .then((resp) => {
                    // console.log('our use ', resp);
                    if (resp.status === 'success') {
                        console.log('===>', resp);
                        this.setState({
                            showLoader:false,
                            showMessage: true,
                            resMessage: resp.message
                        })
                        Swal.fire({
                            text: resp.message,
                            confirmButtonText: `OK`,
                            icon: "success",
                          }).then((data) =>
                          this.props.history.push({
                            pathname: "/login",
                          })
                        );
                        // setTimeout(() => {
                        //     window.location.href = "/#";
                        // },2500)
                    }
                }).catch(error => {
                    this.setState({ showLoader:false});
                    Swal.fire({
                        text: 'Failed to send link',
                        confirmButtonText: `OK`,
                        icon: "error",
                      })
                    console.log(error);
                });
        }
    }

    handleEmail = (e) => {
        const emailRegex = RegExp(
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
          );
        emailRegex.test(e.target.value) ? this.setState({emailError: false}) : this.setState({emailError: true});
        this.setState({
            email: e.target.value,
            showLoader: false,
        });

    }

    render() {
        const { state } = this;
        return (
            <React.Fragment>
                <ThemeProvider theme={this.props.theme}>
                    <div className="email-login-page">
                        <div>
                            <img src={login_navender_logo} />
                        </div>
                        <div className="email-login-form">
                            <form onSubmit={this.submit}>
                                <div>
                                    <label for="fname">Email  <sup className="asterisk">*</sup></label>
                                    <input
                                        name="email"
                                        type="email"
                                        value={state.email}
                                        onChange={this.handleEmail}
                                    />
                                    {state.emailError &&
                                        <div className="email-login-error" >
                                            {'Invalid Email'}</div>
                                    }
                                </div>
                                <div>
                                    <button disabled={state.email === '' || state.showLoader || state.emailError} className="email-login-button" type="submit">{'Send Link'}</button>
                                </div>
                                {state.unauthorized &&
                                    <div className="email-login-error-centered" >
                                        {'Unauthorized User'}</div>
                                }
                                {state.accessBlocked &&
                                    <div className="email-login-error-centered" >
                                        {'Access temporarily blocked due to security reasons. Please try again after 1 hour.'}</div>
                                }
                                {state.showLoader && !state.unauthorized && !state.accessBlocked &&
                                    <div className="login-loader" />
                                }
                                {
                                    state.showMessage &&
                                    <div className="" >
                                        {state.resMessage}</div>
                                }
                                {
                                    state.notValidUser &&
                                    <div className="email-login-error-centered" >
                                        {'Email address not found. Please check and try again.'}</div>
                                }
                            </form>
                        </div>
                    </div>
                </ThemeProvider>
            </React.Fragment>
        );
    }
};
export default ForgotPassword;
